import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
  OnDestroy,
} from "@angular/core";
import { InvoiceReviewOrderLineDetailsService } from "../../../core/services/invoice-review-order-line-details.service";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import buildQuery from "odata-query";
import {
  IRSalesOrderLines,
  GetIRSalesOrderLinesResponse,
} from "../../../core/models/invoice-review/getInvoiceReviewSalesOrderLinesResponse";
import { PoEmailData } from "../../../core/models/orders/PoEmailData";
import { VendorInvoiceJournalDetailValue } from "../../../core/models/orders/vendorInvoiceJournalDetailValue";
import { LoaderService } from "../../../core/services/loader.service";
import { OrderSummaryService } from "../../../core/services/order-summary.service";
import { exportExcel } from "../../../core/services/shared.service";
import { EnumOrderEmailState } from "../../../shared/enums/orderEmailState.enum";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { CDISummaryService } from "../../../core/services/cdi-resolution-summary.service";
import { CommonModule } from "@angular/common";
import { TableModule } from "primeng/table";
import { UnmatchUrlDialogComponent } from "../../orders/components/unmatch-url-dialog/unmatch-url-dialog.component";
import { ModalStackerComponent } from "../../../shared/components/modal-stacker/modal-stacker.component";
import { PoEmailComponent } from "../../orders/components/po-email/po-email.component";
import { HideEmptyDatePipe } from "../../../shared/pipes/hidedate/hide-empty-date.pipe";
import { CdiResolutionSummaryComponent } from "../../cdi/cdi-resolution-summary/cdi-resolution-summary.component";

@UntilDestroy()
@Component({
  selector: "jni-invoice-review-order-line-details",
  templateUrl: "./invoice-review-order-line-details.component.html",
  styleUrls: ["./invoice-review-order-line-details.component.scss"],
  imports: [
    CommonModule,
    TableModule,
    UnmatchUrlDialogComponent,
    ModalStackerComponent,
    PoEmailComponent,
    HideEmptyDatePipe,
    CdiResolutionSummaryComponent,
  ],
})
export class InvoiceReviewOrderLineDetailsComponent
  implements OnInit, OnChanges, OnDestroy
{
  showSmallLoader = false;
  vendorInvoiceJournalDetail: VendorInvoiceJournalDetailValue[] = [];
  unmatchQuantityStatus = false;
  descriptionCharacterCond = false;
  @Input() orderLineDetailsGridListing: IRSalesOrderLines[] = [];
  @Output() vendorInvoiceEvent = new EventEmitter<string>();
  @Output() scrollHiddenStatus = new EventEmitter();
  @Input() invoiceReviewLines: GetIRSalesOrderLinesResponse =
    {} as GetIRSalesOrderLinesResponse;
  poEmailData: PoEmailData = {} as PoEmailData;
  poEmailDisplayModal = false;
  @Input() orderLineDetailsConsumesMessage = "No order line found.";
  @Input() isFromIpSummary = false;
  cdiSummaryDisplayModal = false;
  CDIResolutionNumber = "";
  poNumber = "";
  saleOrderId = "";
  recId = 0;
  totalSell = 0;
  totalCost = 0;
  totalGp = 0;
  totalComm = 0;

  constructor(
    private _invoiceReviewOrderLineDetailsService: InvoiceReviewOrderLineDetailsService,
    private _loaderService: LoaderService,
    private _orderSummaryService: OrderSummaryService,
    private _toastr: JniToastrService,
    private __cdiSummaryService: CDISummaryService
  ) {}

  ngOnInit(): void {
    //ToDo Add code here
    this.ngOnChanges();
  }

  ngOnChanges(): void {
    this.totalSell = this.orderLineDetailsGridListing.reduce(
      (sum, el) => (sum += el.TotalSell ?? 0),
      0
    );

    this.totalCost = this.orderLineDetailsGridListing.reduce(
      (sum, el) => (sum += el.TotalCost ?? 0),
      0
    );

    this.totalGp = this.orderLineDetailsGridListing.reduce(
      (sum, el) => (sum += el.GP ?? 0),
      0
    );

    this.totalComm = this.orderLineDetailsGridListing.reduce(
      (sum, el) => (sum += el.Commission ?? 0),
      0
    );
  }

  openUrlDialog(poNumber: string) {
    if (poNumber) {
      const filter = {
        PurchId: poNumber,
      };
      const query = buildQuery({ filter });
      this.vendorInvoiceJournalDetail = [];
      this._loaderService.setLoaderState(true);
      this._orderSummaryService
        .getUnmatchQuantityUrl(query)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.data) {
              if (res.data.length > 0) {
                this.vendorInvoiceJournalDetail = res.data;
                if (this.vendorInvoiceJournalDetail.length === 1) {
                  const url =
                    this.vendorInvoiceJournalDetail[0].DocumentURL || "";
                  window.open(url, "_blank");
                } else {
                  this.unmatchQuantityStatus = true;
                }
              } else {
                this._toastr.error("Error", "Record not found");
              }
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error("Error", res.message || "Record not found");
          },
        });
    } else {
      this._toastr.error("Error", "PO Number is required");
    }
  }

  closeUrlDialog() {
    this.unmatchQuantityStatus = false;
  }

  exportExcel() {
    exportExcel(this.orderLineDetailsGridListing, "OrderLine Details");
  }

  onLineSelection(salesId: string, projId: string) {
    this._invoiceReviewOrderLineDetailsService.onSalesIdSelection({
      SalesId: salesId,
      ProjId: projId,
    });
  }

  onVendorInvoiceSelection() {
    this.vendorInvoiceEvent.emit();
  }

  ngOnDestroy(): void {
    this.scrollHiddenStatus.emit();
  }

  OpenPoPdf(obj: IRSalesOrderLines) {
    this.poEmailData.saleOrderId = obj.SalesOrderNumber;
    this.poEmailData.poNumber = obj.PurchId;
    this.poEmailData.windowState = EnumOrderEmailState.PoPrinting;
    this.poEmailDisplayModal = true;
  }

  closeModalForPoEmail() {
    this.poEmailDisplayModal = false;
  }

  descriptionCharacterCount(obj: string) {
    if (obj) {
      if (obj.length > 45) this.descriptionCharacterCond = true;
    }
  }

  getStyleOfMatchedPercent(obj: number) {
    if (obj === 100) {
      return "display: inline-block;width:55px;background-color: green;padding: 0.3rem;color: white;font-weight: bold;";
    } else if (obj === 0) {
      return "display: inline-block;width:55px;background-color: red;padding: 0.3rem;color: white;font-weight: bold;";
    } else if (obj < 100) {
      return "display: inline-block;width:55px;background-color: yellow;padding: 0.3rem;color: #0c5a5c;font-weight: bold;";
    }

    return null;
  }

  goToCdi(purchaseOrder: string) {
    if (purchaseOrder) {
      this._loaderService.setLoaderState(true);
      this.__cdiSummaryService
        .getCDISummaryByPurchaseOrder(purchaseOrder)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.data) {
              this.CDIResolutionNumber = res.data.id.toString();
              this.poNumber = res.data.purchaseOrderD365;
              this.saleOrderId = res.data.salesOrderD365;
              this.recId = res.data.recId1D365;
              this.cdiSummaryDisplayModal = true;
            } else {
              this._toastr.error("Error", "No Cdi Record is found");
            }
          },
          error: () => {
            this._loaderService.setLoaderState(false);
            this._toastr.error("Error", "No Cdi Record is found");
          },
        });
    }
  }

  closeModalForCDI() {
    this.cdiSummaryDisplayModal = false;
  }
}
